import styled from 'styled-components';

/**
 * Stylised heading used to define a head of a section of a page
 * Primarily used on the landing page
 */
const Heading = styled.h2`
  font-size: ${props => props.fontSize || '2.5em'};
  letter-spacing: 0.4rem;
  margin: 0;
  font-weight: normal;
  text-align: center;
  word-wrap: break-word;
  font-family: 'DINCondensed-Regular', 'monospace';
`;

/**
 * Subheading usually used directly below Heading
 */
export const SubHeading = styled.h4`
  text-align: center;
  font-size: ${props => props.fontSize || '1em'};
  font-weight: normal;
  margin: ${props => (props.dense ? '0' : '0 0 0.5em 0')};
  letter-spacing: 0.1em;
  @media (max-width: 767px) {
    margin: ${props => (props.dense ? '0' : '0 0 2em 0')};
  }
`;

export default Heading;
